/**
 * V68: 고용형태 코드(SSoT) → 한글 표시 매핑.
 *
 * SSoT: users.currentEmploymentTypeCode (대문자 4 표준).
 *   - REGULAR  → 정규
 *   - INTERN   → 인턴
 *   - DISPATCH → 파견
 *   - CONTRACT → 계약
 *
 * 정책:
 *   - FE 표시 전용 (formatter). DB / BE payload / 필터 비교는 code 그대로.
 *   - 4 표준 외 코드: BE 에서 받은 fallbackName (master_employmentTypes lookup 결과) 사용.
 *   - fallbackName 도 없으면 '-' 또는 원본 code 반환 (호출처 결정).
 */

const KO_MAP: Record<string, string> = {
  REGULAR: '정규',
  INTERN: '인턴',
  DISPATCH: '파견',
  CONTRACT: '계약',
};

/**
 * 고용형태 표시명.
 *
 * @param code  SSoT 코드 (대문자/소문자 무관)
 * @param fallbackName BE 가 보낸 employmentTypeName (master_employmentTypes 한글명 등)
 * @returns 한글 표시명. 매칭 안 되면 fallbackName, 그것도 없으면 '-'
 */
export function formatEmploymentTypeName(
  code: string | null | undefined,
  fallbackName?: string | null,
): string {
  const upper = (code || '').toUpperCase();
  if (KO_MAP[upper]) return KO_MAP[upper];
  if (fallbackName && fallbackName.trim() && fallbackName.toUpperCase() !== upper) {
    return fallbackName;
  }
  return '-';
}
